import { render, staticRenderFns } from "./AgeGroupSelector.vue?vue&type=template&id=401c3bac"
import script from "./AgeGroupSelector.vue?vue&type=script&lang=js"
export * from "./AgeGroupSelector.vue?vue&type=script&lang=js"
import style0 from "./AgeGroupSelector.vue?vue&type=style&index=0&id=401c3bac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports